import React from 'react';

import EmailMessagesList from '@dashboard/components/EmailMessagesList';
import ExportMessagesButton from '@dashboard/components/EmailMessagesList/ExportMessagesButton';
import ButtonLink from '@dashboard/components/mui-atoms/ButtonLink';
import { useRequestLogsListHref } from '@dashboard/hooks/route/hrefs';
import { useCurrentPage } from '@dashboard/hooks/route/useCurrentPage';
import { ListAltOutlined } from '@mui/icons-material';
import { Box, Stack, Tooltip, Typography } from '@mui/material';

import COLUMNS from './columns';
import EmptyPageTutorial from './EmptyPageTutorial';
import { useEmailMessagesFilters } from './hooks';

export default function WaypointsEventsList() {
  const requestLogsHref = useRequestLogsListHref();
  const page = useCurrentPage();

  const [filter, setFilter] = useEmailMessagesFilters();

  return (
    <Stack spacing={1}>
      <EmailMessagesList
        title={
          <Typography variant="h4" component="h1" sx={{ display: { xs: 'none', md: 'block' } }}>
            Activity
          </Typography>
        }
        emptyMessageTutorial={<EmptyPageTutorial />}
        page={page}
        filter={filter}
        setFilter={setFilter}
        columns={COLUMNS}
        actions={({ disabled }) => <ExportMessagesButton filter={filter} disabled={disabled} />}
      />
      <Box sx={{ display: 'block', textAlign: 'right' }}>
        <Tooltip title="View full API request logs">
          <ButtonLink
            startIcon={<ListAltOutlined />}
            href={requestLogsHref}
            size="small"
            sx={{ color: 'text.secondary' }}
          >
            API request logs
          </ButtonLink>
        </Tooltip>
      </Box>
    </Stack>
  );
}
